import { CountryData, WIRPhaseTypes } from 'types/wellGuardian';

export const getPhaseBorderLeftColor = (phaseName: string | undefined, countryState: string) => {
  if (countryState === CountryData.denmark) {
    switch (phaseName) {
      case WIRPhaseTypes.STAGE_GATE_1:
        return '#FFFF00 ';
      case WIRPhaseTypes.STAGE_GATE_2:
        return '#4E5E6F';
      case WIRPhaseTypes.STAGE_GATE_3:
        return '#095d30';
      case WIRPhaseTypes.STAGE_GATE_4:
        return '#00EBBF';
      case WIRPhaseTypes.STAGE_GATE_5:
        return '#EBE376';
      case WIRPhaseTypes.REACTIVE_SCOPE:
        return '#4E5E6F';
      case WIRPhaseTypes.PAUSED_STATE:
        return '#4E5E6F';
    }
  } else {
    switch (phaseName) {
      case WIRPhaseTypes.WIR_CREATED:
      case WIRPhaseTypes.CG_WIR_CREATED:
        return '#4E5E6F';
      case WIRPhaseTypes.KICK_OFF_TECHNICAL_WIR:
      case WIRPhaseTypes.CG_KICK_OFF_TECHNICAL_WIR:
        return '#FF5B64';
      case WIRPhaseTypes.ENGINEERING_WORK:
      case WIRPhaseTypes.CG_ENGINEERING_WORK:
      case WIRPhaseTypes.AG_ENGINEERING_WORK:
      case WIRPhaseTypes.IRAQ_ENGINEERING_WORK:
      case WIRPhaseTypes.ARGENTINA_ENGINEERING_WORK:
        return '#0078EA';
      case WIRPhaseTypes.FINAL_WIR:
      case WIRPhaseTypes.CG_FINAL_WIR:
      case WIRPhaseTypes.AG_FINAL_WIR:
      case WIRPhaseTypes.IRAQ_FINAL_WIR:
      case WIRPhaseTypes.ARGENTINA_FINAL_WIR:
        return '#00C85C';
      case WIRPhaseTypes.FINAL_PREPARATION:
      case WIRPhaseTypes.NG_FINAL_PREPARATION:
      case WIRPhaseTypes.CG_FINAL_PREPARATION:
      case WIRPhaseTypes.AG_FINAL_PREPARATION:
      case WIRPhaseTypes.IRAQ_FINAL_PREPARATION:
      case WIRPhaseTypes.ARGENTINA_FINAL_PREPARATION:
        return '#ECAA00';
      case WIRPhaseTypes.INTERVENTION_OPERATION:
      case WIRPhaseTypes.NG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.CG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.AG_INTERVENTION_OPERATION:
      case WIRPhaseTypes.IRAQ_INTERVENTION_OPERATION:
      case WIRPhaseTypes.ARGENTINA_INTERVENTION_OPERATION:
        return '#00EBBF';
      case WIRPhaseTypes.INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.NG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.CG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.AG_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.IRAQ_INTERVENTION_CLOSE_OUT:
      case WIRPhaseTypes.ARGENTINA_INTERVENTION_CLOSE_OUT:
        return '#EBE376';
      case WIRPhaseTypes.REACTIVE_SCOPE:
        return '#4E5E6F';
      case WIRPhaseTypes.PAUSED_STATE:
        return '#4E5E6F';
    }
  }
};
